import type { RouteObject } from "react-router-dom";
import ReportsIndexPage from "./Index";
import SalesReportPage from "./Sales";
import PipelineReportPage, { pipelineReportLoader } from "./Pipeline";
import StockMovementReportPage from "./StockMovement";
import VarianceReportPage from "./Variance";
import CollisionsReportPage from "./Collisions";
import OrderToInvoiceReportPage from "./OrderToInvoice";
import StalenessReportPage, { stalenessReportLoader } from "./Staleness";
import ReapplyPreviewPage, { reapplyPreviewLoader } from "./ReapplyPreview";
import AppError from "../app-error";

/**
 * T027/US5, 008-reporting-dashboards T015/T019/T020/T021/T023/T024/T025. `reports` is the index
 * (T025) — it only links to the routes below and to `006`'s `/invoicing/gst-summary`, never
 * re-rendering either (FR-016, SC-008).
 */
export const reportsRoutes: RouteObject[] = [
  { path: "reports", Component: ReportsIndexPage, errorElement: <AppError /> },
  { path: "reports/sales", Component: SalesReportPage, errorElement: <AppError /> },
  { path: "reports/pipeline", Component: PipelineReportPage, loader: pipelineReportLoader, errorElement: <AppError /> },
  { path: "reports/stock-movement", Component: StockMovementReportPage, errorElement: <AppError /> },
  { path: "reports/variance", Component: VarianceReportPage, errorElement: <AppError /> },
  { path: "reports/collisions", Component: CollisionsReportPage, errorElement: <AppError /> },
  { path: "reports/order-to-invoice", Component: OrderToInvoiceReportPage, errorElement: <AppError /> },
  { path: "reports/staleness", Component: StalenessReportPage, loader: stalenessReportLoader, errorElement: <AppError /> },
  // 001-catalogue-admin-screens T077/T078: previewId in the path (data-model §6) so a refresh
  // returns to the same preview rather than losing it.
  { path: "reports/staleness/reapply/:previewNumber", Component: ReapplyPreviewPage, loader: reapplyPreviewLoader, errorElement: <AppError /> },
];
